import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  visit(event) {
    location.assign(this.data.get("url"))
  }
}
